<template>
  <div class="home-page">
    <Header />
    <Hero :content="data.hero" />
    <Carousel :content="data.carousel" />
    <AboutSection :content="data.about" />
    <GameElements :content="data.gameElements" />
    <VideoPlayer v-if="data.video" :content="data.video" />
    <InstagramPosts v-if="data.instagram" :content="data.instagram" />
    <SocialLinks :content="data.social" />
    <Footer :content="data.footer" />
  </div>
</template>

<script>
import Header from '../Header/Header.vue'
import Hero from '../Hero/Hero.vue'
import Carousel from '../Carousel/Carousel.vue'
import AboutSection from '../AboutSection.vue'
import GameElements from '../GameElements'
import VideoPlayer from '../VideoPlayer.vue'
import InstagramPosts from '../InstagramPosts.vue'
import SocialLinks from '../SocialLinks.vue'
import Footer from '../Footer.vue'

export default {
  name: 'HomePage',
  components: {
    Header,
    Hero,
    Carousel,
    AboutSection,
    GameElements,
    VideoPlayer,
    InstagramPosts,
    SocialLinks,
    Footer
  },
  props: {
    data: {
      type: Object,
      required: true
    }
  }
}
</script>

<style scoped>
.home-page {
  min-height: 100vh;
}
</style>
